import React from "react";
import { useKeycloak } from "../hooks/useKeycloak";
import { Navigate, Outlet } from "react-router-dom";
import { PRE_WEBAUTHN_USER_ROLE, WEBAUTHN_USER_ROLE } from "./RoleConstants";
const PrivateRoute = (props) => {
    const { roles } = props;
    const { keycloak } = useKeycloak();
    const hasAccessRoles = () => {
        return keycloak.hasRealmRole(PRE_WEBAUTHN_USER_ROLE) || keycloak.hasRealmRole(WEBAUTHN_USER_ROLE);
    };
    const hasAccessPermission = () => {
        if (keycloak && roles) {
            return keycloak.authenticated && hasAccessRoles();
        }
        return keycloak.authenticated;
    };
    //react-router-dom#Navigate is currently not testable properly: see https://github.com/remix-run/react-router/issues/8733
    return hasAccessPermission() ? React.createElement(Outlet, null) : React.createElement(Navigate, { replace: true, to: "/forbidden" });
};
export default PrivateRoute;
